import {inject, Injectable} from "@angular/core";
import {DataStorageService} from "src/app/infrastructure/data-storage.service";
import {UserApiClient} from "src/app/infrastructure/moovement-api/web-api/user.api-client";
import {User} from "src/app/infrastructure/moovement-api/models/user";
import {UserStore} from "src/app/domain/user/user.store";
import {Samples} from "src/app/infrastructure/moovement-api/models/samples";

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private userStore = inject(UserStore);

  constructor(
    private dataStorageService: DataStorageService,
    private userApiClient: UserApiClient
  ) {}

  async init(user: User) {
    await this.store(user);
  }

  private async store(user: User) {
    this.userStore.setUser(user);
    await this.dataStorageService.addKeyValuePair('user', user);
  }

  async refresh() {
    const user = await this.dataStorageService.getValueByKey<User>('user');
    if (!user) return;

    this.userStore.setLoading(true);

    return new Promise<void>((resolve, _) => {
      this.userApiClient.getUser(user.id).subscribe({
        next: async user => {
          await this.store(user);
          resolve()
        },
        error: async _ => {
          await this.store(user);
          resolve();
        }
      })
    });
  }

  togglePreference(key: Samples.AlertStatus) {
    const user = this.userStore.user();
    if (!user) return;

    this.userStore.setLoading(true);
    const preferences = user.preferences.notifications;
    const enabled = preferences[key] !== false;
    preferences[key] = !enabled;
    user.preferences.notifications = preferences;

    this.userApiClient.updateUser(user).subscribe({
      next: async updatedUser => {
        await this.store(updatedUser);
      },
      error: _ => {
        this.userStore.setLoading(false);
      }
    });
  }
}
